// App.js
import './App.css';
import { useNavigate, Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Writing from "./pages/Writing";
import Haiku from "./pages/Haiku";

export default function App() {
  const navigate = useNavigate();

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>Connor's Portfolio</h1>
        <button className="home-button" onClick={() => navigate("/")}>
          About Me
        </button>
        <button className="home-button" onClick={() => navigate("/writing")}> 
          Writing
        </button>
        <button className="home-button" onClick={() => navigate("/haiku")}> 
          Haiku
        </button>
      </header>

      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/about" element={<About />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/haiku" element={<Haiku />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <footer className="app-footer">
        <button className="home-button" onClick={() => navigate("/contact")}> 
          Contact Me
        </button>
        <p>© 2026 Connor Chartier</p>
      </footer>
    </div>
  );
}
